export const TOAST_TIMEOUT = 3000;

export enum AddToCartButtonType {
  ADD_TO_CART_BUTTON = 'ADD_TO_CART_BUTTON',
  ADD_TO_CART_BUTTON_WITHSTEPPER = 'ADD_TO_CART_BUTTON_WITHSTEPPER',
  ADD_TO_LIST_BUTTON = 'ADD_TO_LIST_BUTTON',
}

export const MAX_QTY = 99;
